import React, { Component } from 'react';
import moment from 'moment';
import { Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import GridView from '../../../components/elements/GridView/index';
import { LocationFilled, NotificationFilled, PlugFilled, FlagFilled } from '@carbon/icons-react';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import Spinner from '../../../components/Spinner';

const { DB_DATE_FORMAT } = require('../../../core/constants').default;

class DriverEventHistoryTab extends Component {
    onPageChange = (page, pageSize) => {
        const { onPageChange } = this.props;

        onPageChange(page, pageSize);
    };

    onTableChange = (pagination, filters, sorter, extra) => {
        const { onTableChange, driverEventsPagination } = this.props;

        // Only call onTableChange if the page is the same or we are actually sorting
        if (pagination && pagination.current === driverEventsPagination.currentPage) {
            onTableChange(pagination, filters, sorter, extra);
        }
    };

    render() {
        const {
            driverEvents,
            driverEventsPagination,
            onExportDriverEventCSV,
            isExportingDriverEventHistoryCsv,
            isLoadingEvents,
        } = this.props;

        const listDriverEventHistory = driverEvents ? driverEvents.map((event) => {
            const iconStyle = {};
            iconStyle.fontSize = '16px';
            iconStyle.color = '#CF2B28';
            const tempEvent = {};
            let eventTitle = event.event_name;
            if (event.event_type == 253) {
                if (event.green_driving_type == 0) {
                    eventTitle = 'Eco-friendly driving';
                } else if (event.green_driving_type == 1) {
                    eventTitle = 'Harsh accelerating';
                } else if (event.green_driving_type == 2) {
                    eventTitle = 'Harsh braking';
                } else if (event.green_driving_type == 3) {
                    eventTitle = 'Harsh cornering';
                }
            }
            tempEvent.event_type = (
                <Tooltip
                    placement="top"
                    title={eventTitle}
                >
                <NotificationFilled
                    size={20}
                    style={{
                        color: 'var(--red)',
                        verticalAlign: 'middle',
                    }}
                />
                    &ensp;
                    {event.event_name}
                </Tooltip>
            );
            if (event.icon && event.icon !== '') {
            switch (event.icon) {
                case 'alert':
                case 'bell':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                        <NotificationFilled
                            size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                        />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                    );
                    break;
                case 'api':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                        <PlugFilled
                            size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                        />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                    );
                    break;
                case 'environment':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                        <LocationFilled
                            size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                        />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                    );
                    break;
                case 'flag':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                        <FlagFilled
                            size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                        />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                    );
                    break;
                default:
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                                <NotificationFilled
                                    size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                                />
                                &ensp;
                                {event.event_name}
                    </Tooltip>
                        );
                }
            }
            tempEvent.date = moment(event.date, DB_DATE_FORMAT).format('DD/MM/YYYY');
            tempEvent.time = moment(event.time, 'hh:mm A').format('hh:mm A');
            tempEvent.location = event.location_name;
            tempEvent.asset = event.asset_name;
            tempEvent.registration = <Link to={`/assets/view/${event.asset_id}`}>{event.registration}</Link>;
            tempEvent.actions = (
                    <Link
                    className="btn-actions"
                        to={`/events/custom-view/${event.id}/${event.device_id}`}

                    >
                            View
                        </Link>

            );
            return tempEvent;
        }) : [];

        return (
            <>
                <Spinner 
                    loading={isLoadingEvents} 
                    minHeight={200}
                >
                    {driverEvents.length > 0 && (
                        <>
                            <Button
                                type="primary"
                                className="export-csv-button"
                                onClick={onExportDriverEventCSV}
                                style={{ marginBottom: '16px' }}
                                loading={isExportingDriverEventHistoryCsv}
                                data-testid='driver-details-events_export-btn'
                            >
                                Export
                            </Button>
                            <br />
                        </>
                    )}
                    <div style={{ opacity: isLoadingEvents ? 0 : 1 }}>
                        <GridView
                            data={listDriverEventHistory}
                            onChange={this.onTableChange}
                            sortableColumns={['event_type', 'date', 'time', 'asset', 'registration']}
                            pagination={{
                                total: parseInt(driverEventsPagination.totalRecords, 10),
                                showSizeChanger: false,
                                pageSize: parseInt(driverEventsPagination.perPageCount, 10),
                                onChange: this.onPageChange,
                                current: parseInt(driverEventsPagination.currentPage, 10),
                                showTotal: getPaginationTotal,
                            }}
                        />
                    </div>
                </Spinner>
            </>
        );
    }
}

DriverEventHistoryTab.defaultProps = {
    setLoadedState: () => null,
    eventsHistoryTabLoaded: false,
    driverId: '',
    onPageChange: () => null,
    onTableChange: () => null,
    driverEvents: [],
    driverEventsPagination: {},
};

DriverEventHistoryTab.propTypes = {
    setLoadedState: PropTypes.func,
    eventsHistoryTabLoaded: PropTypes.bool,
    driverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onPageChange: PropTypes.func,
    onTableChange: PropTypes.func,
    onExportDriverEventCSV: PropTypes.func.isRequired,
    driverEvents: PropTypes.array,
    driverEventsPagination: PropTypes.shape({
        currentPage: PropTypes.number,
        perPageCount: PropTypes.number,
        totalRecords: PropTypes.number,
    }),
    isExportingDriverEventHistoryCsv: PropTypes.bool,
};

export default DriverEventHistoryTab;
